import React from "react";

export default function Error503() {
  return (
    <svg
      width="296"
      height="148"
      viewBox="0 0 296 148"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M239 48.0974C255.887 79.6999 245.593 146.699 218.776 138.001C191.958 129.302 160.683 128.721 72.3645 136.395C-15.9538 144.07 42.3219 55.8184 64.5311 24.5992C75.0692 9.786 99.745 14.5758 116.373 7.81602C139.222 -1.4726 155.607 4.9161 179.182 12.0485C205.174 19.9118 225.984 23.7391 239 48.0974Z"
        fill="url(#paint0_linear_416_7934)"
      />
      <path
        d="M201.416 19.6533C201.416 24.1794 205.459 27.8486 210.447 27.8486C215.434 27.8486 219.477 24.1794 219.477 19.6533C219.477 15.1272 215.434 11.458 210.447 11.458C205.459 11.458 201.416 15.1272 201.416 19.6533Z"
        fill="url(#paint1_linear_416_7934)"
      />
      <path
        d="M207.817 23.3879C207.817 27.914 211.861 31.5832 216.848 31.5832C221.836 31.5832 225.879 27.914 225.879 23.3879C225.879 18.8617 221.836 15.1926 216.848 15.1926C211.861 15.1926 207.817 18.8617 207.817 23.3879Z"
        fill="url(#paint2_linear_416_7934)"
      />
      <path
        d="M192.956 24.529C192.956 28.1957 196.232 31.1682 200.273 31.1682C204.313 31.1682 207.589 28.1957 207.589 24.529C207.589 20.8622 204.313 17.8898 200.273 17.8898C196.232 17.8898 192.956 20.8622 192.956 24.529Z"
        fill="url(#paint3_linear_416_7934)"
      />
      <path
        d="M192.956 24.529C192.956 28.1957 196.232 31.1682 200.273 31.1682C204.313 31.1682 207.589 28.1957 207.589 24.529C207.589 20.8622 204.313 17.8898 200.273 17.8898C196.232 17.8898 192.956 20.8622 192.956 24.529Z"
        fill="url(#paint4_linear_416_7934)"
      />
      <path
        d="M215.133 28.471C215.133 32.1378 218.409 35.1103 222.45 35.1103C226.49 35.1103 229.766 32.1378 229.766 28.471C229.766 24.8043 226.49 21.8318 222.45 21.8318C218.409 21.8318 215.133 24.8043 215.133 28.471Z"
        fill="url(#paint5_linear_416_7934)"
      />
      <path
        d="M200.501 31.5832C200.501 35.2499 203.777 38.2224 207.817 38.2224C211.858 38.2224 215.133 35.2499 215.133 31.5832C215.133 27.9164 211.858 24.9439 207.817 24.9439C203.777 24.9439 200.501 27.9164 200.501 31.5832Z"
        fill="url(#paint6_linear_416_7934)"
      />
      <path
        d="M207.817 32.828C207.817 36.4948 211.093 39.4672 215.133 39.4672C219.174 39.4672 222.45 36.4948 222.45 32.828C222.45 29.1613 219.174 26.1888 215.133 26.1888C211.093 26.1888 207.817 29.1613 207.817 32.828Z"
        fill="url(#paint7_linear_416_7934)"
      />
      <path
        d="M187.241 27.8486C187.241 30.5987 189.697 32.828 192.728 32.828C195.758 32.828 198.215 30.5987 198.215 27.8486C198.215 25.0985 195.758 22.8692 192.728 22.8692C189.697 22.8692 187.241 25.0985 187.241 27.8486Z"
        fill="url(#paint8_linear_416_7934)"
      />
      <path
        d="M224.279 30.7533C224.279 33.5033 226.735 35.7327 229.766 35.7327C232.796 35.7327 235.253 33.5033 235.253 30.7533C235.253 28.0032 232.796 25.7738 229.766 25.7738C226.735 25.7738 224.279 28.0032 224.279 30.7533Z"
        fill="url(#paint9_linear_416_7934)"
      />
      <path
        d="M219.477 34.4878C219.477 37.2379 221.934 39.4672 224.964 39.4672C227.995 39.4672 230.452 37.2379 230.452 34.4878C230.452 31.7378 227.995 29.5084 224.964 29.5084C221.934 29.5084 219.477 31.7378 219.477 34.4878Z"
        fill="url(#paint10_linear_416_7934)"
      />
      <path
        d="M227.708 33.8654C227.708 36.6155 230.165 38.8448 233.195 38.8448C236.226 38.8448 238.682 36.6155 238.682 33.8654C238.682 31.1153 236.226 28.886 233.195 28.886C230.165 28.886 227.708 31.1153 227.708 33.8654Z"
        fill="url(#paint11_linear_416_7934)"
      />
      <path
        d="M192.956 32.828C192.956 35.5781 195.413 37.8074 198.444 37.8074C201.474 37.8074 203.931 35.5781 203.931 32.828C203.931 30.078 201.474 27.8486 198.444 27.8486C195.413 27.8486 192.956 30.078 192.956 32.828Z"
        fill="url(#paint12_linear_416_7934)"
      />
      <path
        d="M184.04 31.4794C184.04 33.4847 185.831 35.1103 188.041 35.1103C190.251 35.1103 192.042 33.4847 192.042 31.4794C192.042 29.4742 190.251 27.8486 188.041 27.8486C185.831 27.8486 184.04 29.4742 184.04 31.4794Z"
        fill="url(#paint13_linear_416_7934)"
      />
      <path
        d="M187.927 33.7617C187.927 35.7669 189.718 37.3925 191.928 37.3925C194.137 37.3925 195.929 35.7669 195.929 33.7617C195.929 31.7564 194.137 30.1308 191.928 30.1308C189.718 30.1308 187.927 31.7564 187.927 33.7617Z"
        fill="url(#paint14_linear_416_7934)"
      />
      <path
        d="M234.796 34.1766C234.796 36.1819 236.587 37.8074 238.797 37.8074C241.006 37.8074 242.798 36.1819 242.798 34.1766C242.798 32.1714 241.006 30.5458 238.797 30.5458C236.587 30.5458 234.796 32.1714 234.796 34.1766Z"
        fill="url(#paint15_linear_416_7934)"
      />
      <path
        d="M180.382 33.7617C180.382 35.194 181.661 36.3551 183.24 36.3551C184.818 36.3551 186.098 35.194 186.098 33.7617C186.098 32.3293 184.818 31.1682 183.24 31.1682C181.661 31.1682 180.382 32.3293 180.382 33.7617Z"
        fill="url(#paint16_linear_416_7934)"
      />
      <path
        d="M239.597 34.1766C239.597 35.6089 240.876 36.7701 242.455 36.7701C244.033 36.7701 245.312 35.6089 245.312 34.1766C245.312 32.7443 244.033 31.5832 242.455 31.5832C240.876 31.5832 239.597 32.7443 239.597 34.1766Z"
        fill="url(#paint17_linear_416_7934)"
      />
      <path
        d="M186.829 8.26741C186.829 12.8334 183.127 16.5348 178.561 16.5348C173.995 16.5348 170.294 12.8334 170.294 8.26741C170.294 3.70144 173.995 0 178.561 0C183.127 0 186.829 3.70144 186.829 8.26741Z"
        fill="url(#paint18_linear_416_7934)"
      />
      <path
        d="M180.968 12.0348C180.968 16.6008 177.267 20.3022 172.701 20.3022C168.135 20.3022 164.433 16.6008 164.433 12.0348C164.433 7.46887 168.135 3.76743 172.701 3.76743C177.267 3.76743 180.968 7.46887 180.968 12.0348Z"
        fill="url(#paint19_linear_416_7934)"
      />
      <path
        d="M194.573 13.186C194.573 16.885 191.574 19.8836 187.875 19.8836C184.176 19.8836 181.178 16.885 181.178 13.186C181.178 9.48698 184.176 6.48835 187.875 6.48835C191.574 6.48835 194.573 9.48698 194.573 13.186Z"
        fill="url(#paint20_linear_416_7934)"
      />
      <path
        d="M194.573 13.186C194.573 16.885 191.574 19.8836 187.875 19.8836C184.176 19.8836 181.178 16.885 181.178 13.186C181.178 9.48698 184.176 6.48835 187.875 6.48835C191.574 6.48835 194.573 9.48698 194.573 13.186Z"
        fill="url(#paint21_linear_416_7934)"
      />
      <path
        d="M174.271 17.1627C174.271 20.8617 171.272 23.8604 167.573 23.8604C163.874 23.8604 160.875 20.8617 160.875 17.1627C160.875 13.4637 163.874 10.4651 167.573 10.4651C171.272 10.4651 174.271 13.4637 174.271 17.1627Z"
        fill="url(#paint22_linear_416_7934)"
      />
      <path
        d="M187.666 20.3022C187.666 24.0013 184.667 26.9999 180.968 26.9999C177.269 26.9999 174.271 24.0013 174.271 20.3022C174.271 16.6032 177.269 13.6046 180.968 13.6046C184.667 13.6046 187.666 16.6032 187.666 20.3022Z"
        fill="url(#paint23_linear_416_7934)"
      />
      <path
        d="M180.968 21.5581C180.968 25.2571 177.97 28.2557 174.271 28.2557C170.572 28.2557 167.573 25.2571 167.573 21.5581C167.573 17.859 170.572 14.8604 174.271 14.8604C177.97 14.8604 180.968 17.859 180.968 21.5581Z"
        fill="url(#paint24_linear_416_7934)"
      />
      <path
        d="M199.806 16.5348C199.806 19.3091 197.557 21.5581 194.782 21.5581C192.008 21.5581 189.759 19.3091 189.759 16.5348C189.759 13.7606 192.008 11.5116 194.782 11.5116C197.557 11.5116 199.806 13.7606 199.806 16.5348Z"
        fill="url(#paint25_linear_416_7934)"
      />
      <path
        d="M165.898 19.465C165.898 22.2393 163.649 24.4883 160.875 24.4883C158.101 24.4883 155.852 22.2393 155.852 19.465C155.852 16.6908 158.101 14.4418 160.875 14.4418C163.649 14.4418 165.898 16.6908 165.898 19.465Z"
        fill="url(#paint26_linear_416_7934)"
      />
      <path
        d="M170.294 23.2325C170.294 26.0067 168.045 28.2557 165.271 28.2557C162.496 28.2557 160.247 26.0067 160.247 23.2325C160.247 20.4582 162.496 18.2092 165.271 18.2092C168.045 18.2092 170.294 20.4582 170.294 23.2325Z"
        fill="url(#paint27_linear_416_7934)"
      />
      <path
        d="M162.759 22.6046C162.759 25.3788 160.51 27.6278 157.736 27.6278C154.961 27.6278 152.712 25.3788 152.712 22.6046C152.712 19.8303 154.961 17.5813 157.736 17.5813C160.51 17.5813 162.759 19.8303 162.759 22.6046Z"
        fill="url(#paint28_linear_416_7934)"
      />
      <path
        d="M194.573 21.5581C194.573 24.3323 192.324 26.5813 189.55 26.5813C186.775 26.5813 184.526 24.3323 184.526 21.5581C184.526 18.7838 186.775 16.5348 189.55 16.5348C192.324 16.5348 194.573 18.7838 194.573 21.5581Z"
        fill="url(#paint29_linear_416_7934)"
      />
      <path
        d="M202.736 20.1976C202.736 22.2205 201.096 23.8604 199.073 23.8604C197.05 23.8604 195.41 22.2205 195.41 20.1976C195.41 18.1747 197.05 16.5348 199.073 16.5348C201.096 16.5348 202.736 18.1747 202.736 20.1976Z"
        fill="url(#paint30_linear_416_7934)"
      />
      <path
        d="M199.178 22.4999C199.178 24.5228 197.538 26.1627 195.515 26.1627C193.492 26.1627 191.852 24.5228 191.852 22.4999C191.852 20.477 193.492 18.8371 195.515 18.8371C197.538 18.8371 199.178 20.477 199.178 22.4999Z"
        fill="url(#paint31_linear_416_7934)"
      />
      <path
        d="M156.271 22.9185C156.271 24.9414 154.631 26.5813 152.608 26.5813C150.585 26.5813 148.945 24.9414 148.945 22.9185C148.945 20.8956 150.585 19.2557 152.608 19.2557C154.631 19.2557 156.271 20.8956 156.271 22.9185Z"
        fill="url(#paint32_linear_416_7934)"
      />
      <path
        d="M206.085 22.4999C206.085 23.9448 204.913 25.1162 203.468 25.1162C202.023 25.1162 200.852 23.9448 200.852 22.4999C200.852 21.055 202.023 19.8836 203.468 19.8836C204.913 19.8836 206.085 21.055 206.085 22.4999Z"
        fill="url(#paint33_linear_416_7934)"
      />
      <path
        d="M151.875 22.9185C151.875 24.3634 150.704 25.5348 149.259 25.5348C147.814 25.5348 146.643 24.3634 146.643 22.9185C146.643 21.4736 147.814 20.3022 149.259 20.3022C150.704 20.3022 151.875 21.4736 151.875 22.9185Z"
        fill="url(#paint34_linear_416_7934)"
      />
      <path
        d="M81.6859 8.1953C81.6859 12.7214 77.6426 16.3906 72.655 16.3906C67.6674 16.3906 63.6242 12.7214 63.6242 8.1953C63.6242 3.66916 67.6674 0 72.655 0C77.6426 0 81.6859 3.66916 81.6859 8.1953Z"
        fill="url(#paint35_linear_416_7934)"
      />
      <path
        d="M75.2843 11.9299C75.2843 16.456 71.241 20.1252 66.2534 20.1252C61.2658 20.1252 57.2225 16.456 57.2225 11.9299C57.2225 7.40372 61.2658 3.73456 66.2534 3.73456C71.241 3.73456 75.2843 7.40372 75.2843 11.9299Z"
        fill="url(#paint36_linear_416_7934)"
      />
      <path
        d="M90.1452 13.071C90.1452 16.7377 86.8696 19.7102 82.829 19.7102C78.7884 19.7102 75.5129 16.7377 75.5129 13.071C75.5129 9.40423 78.7884 6.43175 82.829 6.43175C86.8696 6.43175 90.1452 9.40423 90.1452 13.071Z"
        fill="url(#paint37_linear_416_7934)"
      />
      <path
        d="M90.1452 13.071C90.1452 16.7377 86.8696 19.7102 82.829 19.7102C78.7884 19.7102 75.5129 16.7377 75.5129 13.071C75.5129 9.40423 78.7884 6.43175 82.829 6.43175C86.8696 6.43175 90.1452 9.40423 90.1452 13.071Z"
        fill="url(#paint38_linear_416_7934)"
      />
      <path
        d="M67.9681 17.013C67.9681 20.6798 64.6926 23.6522 60.652 23.6522C56.6114 23.6522 53.3359 20.6798 53.3359 17.013C53.3359 13.3463 56.6114 10.3738 60.652 10.3738C64.6926 10.3738 67.9681 13.3463 67.9681 17.013Z"
        fill="url(#paint39_linear_416_7934)"
      />
      <path
        d="M82.6004 20.1252C82.6004 23.7919 79.3249 26.7644 75.2843 26.7644C71.2437 26.7644 67.9681 23.7919 67.9681 20.1252C67.9681 16.4584 71.2437 13.4859 75.2843 13.4859C79.3249 13.4859 82.6004 16.4584 82.6004 20.1252Z"
        fill="url(#paint40_linear_416_7934)"
      />
      <path
        d="M75.2843 21.37C75.2843 25.0368 72.0087 28.0092 67.9681 28.0092C63.9275 28.0092 60.652 25.0368 60.652 21.37C60.652 17.7033 63.9275 14.7308 67.9681 14.7308C72.0087 14.7308 75.2843 17.7033 75.2843 21.37Z"
        fill="url(#paint41_linear_416_7934)"
      />
      <path
        d="M95.8609 16.3906C95.8609 19.1406 93.4042 21.37 90.3738 21.37C87.3433 21.37 84.8867 19.1406 84.8867 16.3906C84.8867 13.6405 87.3433 11.4112 90.3738 11.4112C93.4042 11.4112 95.8609 13.6405 95.8609 16.3906Z"
        fill="url(#paint42_linear_416_7934)"
      />
      <path
        d="M58.823 19.2953C58.823 22.0453 56.3663 24.2747 53.3359 24.2747C50.3054 24.2747 47.8487 22.0453 47.8487 19.2953C47.8487 16.5452 50.3054 14.3158 53.3359 14.3158C56.3663 14.3158 58.823 16.5452 58.823 19.2953Z"
        fill="url(#paint43_linear_416_7934)"
      />
      <path
        d="M63.6242 23.0298C63.6242 25.7799 61.1675 28.0092 58.1371 28.0092C55.1066 28.0092 52.65 25.7799 52.65 23.0298C52.65 20.2798 55.1066 18.0504 58.1371 18.0504C61.1675 18.0504 63.6242 20.2798 63.6242 23.0298Z"
        fill="url(#paint44_linear_416_7934)"
      />
      <path
        d="M55.3935 22.4074C55.3935 25.1574 52.9369 27.3868 49.9064 27.3868C46.876 27.3868 44.4193 25.1574 44.4193 22.4074C44.4193 19.6573 46.876 17.428 49.9064 17.428C52.9369 17.428 55.3935 19.6573 55.3935 22.4074Z"
        fill="url(#paint45_linear_416_7934)"
      />
      <path
        d="M90.1452 21.37C90.1452 24.1201 87.6885 26.3494 84.6581 26.3494C81.6276 26.3494 79.171 24.1201 79.171 21.37C79.171 18.62 81.6276 16.3906 84.6581 16.3906C87.6885 16.3906 90.1452 18.62 90.1452 21.37Z"
        fill="url(#paint46_linear_416_7934)"
      />
      <path
        d="M99.0617 20.0214C99.0617 22.0267 97.2704 23.6522 95.0607 23.6522C92.851 23.6522 91.0597 22.0267 91.0597 20.0214C91.0597 18.0162 92.851 16.3906 95.0607 16.3906C97.2704 16.3906 99.0617 18.0162 99.0617 20.0214Z"
        fill="url(#paint47_linear_416_7934)"
      />
      <path
        d="M95.175 22.3037C95.175 24.3089 93.3837 25.9345 91.174 25.9345C88.9643 25.9345 87.173 24.3089 87.173 22.3037C87.173 20.2984 88.9643 18.6728 91.174 18.6728C93.3837 18.6728 95.175 20.2984 95.175 22.3037Z"
        fill="url(#paint48_linear_416_7934)"
      />
      <path
        d="M48.306 22.7186C48.306 24.7239 46.5147 26.3494 44.305 26.3494C42.0953 26.3494 40.304 24.7239 40.304 22.7186C40.304 20.7134 42.0953 19.0878 44.305 19.0878C46.5147 19.0878 48.306 20.7134 48.306 22.7186Z"
        fill="url(#paint49_linear_416_7934)"
      />
      <path
        d="M102.72 22.3037C102.72 23.736 101.44 24.8971 99.8619 24.8971C98.2836 24.8971 97.004 23.736 97.004 22.3037C97.004 20.8713 98.2836 19.7102 99.8619 19.7102C101.44 19.7102 102.72 20.8713 102.72 22.3037Z"
        fill="url(#paint50_linear_416_7934)"
      />
      <path
        d="M43.5048 22.7186C43.5048 24.1509 42.2253 25.3121 40.6469 25.3121C39.0686 25.3121 37.7891 24.1509 37.7891 22.7186C37.7891 21.2863 39.0686 20.1252 40.6469 20.1252C42.2253 20.1252 43.5048 21.2863 43.5048 22.7186Z"
        fill="url(#paint51_linear_416_7934)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M213.5 58.1397C213.244 58.2627 213.137 58.5693 213.26 58.8244C213.383 59.0795 213.69 59.1866 213.945 59.0636C218.308 56.9599 223.55 58.7913 225.654 63.154C225.777 63.4091 226.084 63.5162 226.339 63.3932C226.594 63.2702 226.701 62.9636 226.578 62.7085C224.228 57.8356 218.373 55.79 213.5 58.1397ZM214.092 60.6203C213.969 60.3652 214.076 60.0587 214.331 59.9356C218.132 58.1026 222.7 59.6984 224.534 63.4998C224.657 63.7549 224.55 64.0615 224.295 64.1845C224.039 64.3075 223.733 64.2004 223.61 63.9453C222.022 60.6541 218.068 59.2726 214.776 60.8595C214.521 60.9825 214.215 60.8755 214.092 60.6203ZM214.897 62.4755C214.774 62.2203 214.881 61.9138 215.136 61.7908C217.943 60.4375 221.315 61.6156 222.669 64.422C222.792 64.6771 222.685 64.9837 222.429 65.1067C222.174 65.2297 221.868 65.1226 221.745 64.8675C220.637 62.5713 217.878 61.6075 215.582 62.7146C215.327 62.8377 215.02 62.7306 214.897 62.4755ZM215.686 64.3869C215.563 64.1318 215.671 63.8252 215.926 63.7022C217.737 62.8287 219.914 63.5891 220.787 65.4005C220.91 65.6557 220.803 65.9622 220.548 66.0852C220.293 66.2083 219.987 66.1012 219.864 65.846C219.236 64.5448 217.672 63.9987 216.371 64.6261C216.116 64.7491 215.81 64.642 215.686 64.3869ZM218.118 67.2278C218.598 66.9963 218.799 66.4196 218.568 65.9395C218.336 65.4595 217.759 65.258 217.279 65.4895C216.799 65.7209 216.598 66.2977 216.829 66.7777C217.061 67.2578 217.638 67.4593 218.118 67.2278Z"
        fill="url(#paint52_linear_416_7934)"
      />
      <path
        d="M213.26 58.8244L213.547 58.6861L213.26 58.8244ZM213.5 58.1397L213.361 57.853L213.361 57.853L213.5 58.1397ZM213.945 59.0636L213.807 58.7769L213.807 58.7769L213.945 59.0636ZM225.654 63.154L225.941 63.0158L225.654 63.154ZM226.578 62.7085L226.865 62.5702L226.578 62.7085ZM214.331 59.9356L214.193 59.6489L214.331 59.9356ZM224.534 63.4998L224.247 63.6381L224.534 63.4998ZM223.61 63.9453L223.323 64.0836L223.61 63.9453ZM214.776 60.8595L214.638 60.5728L214.638 60.5728L214.776 60.8595ZM215.136 61.7908L214.998 61.5041L214.998 61.5041L215.136 61.7908ZM222.669 64.422L222.382 64.5603L222.669 64.422ZM222.429 65.1067L222.291 64.82L222.291 64.82L222.429 65.1067ZM221.745 64.8675L221.458 65.0058L221.458 65.0058L221.745 64.8675ZM215.582 62.7146L215.444 62.4279L215.444 62.4279L215.582 62.7146ZM215.926 63.7022L216.064 63.9889L216.064 63.9889L215.926 63.7022ZM215.686 64.3869L215.4 64.5251L215.4 64.5252L215.686 64.3869ZM220.787 65.4005L220.501 65.5388L220.501 65.5388L220.787 65.4005ZM220.548 66.0852L220.41 65.7985L220.41 65.7985L220.548 66.0852ZM219.864 65.846L220.15 65.7078L219.864 65.846ZM216.371 64.6261L216.509 64.9128L216.509 64.9128L216.371 64.6261ZM218.568 65.9395L218.281 66.0778L218.568 65.9395ZM218.118 67.2278L217.98 66.9411L217.98 66.9411L218.118 67.2278ZM217.279 65.4895L217.418 65.7761L217.418 65.7761L217.279 65.4895ZM213.547 58.6861C213.5 58.5893 213.541 58.4731 213.638 58.4264L213.361 57.853C212.948 58.0524 212.774 58.5492 212.974 58.9627L213.547 58.6861ZM213.807 58.7769C213.71 58.8236 213.594 58.7829 213.547 58.6861L212.974 58.9627C213.173 59.3761 213.67 59.5496 214.083 59.3503L213.807 58.7769ZM225.941 63.0158C223.761 58.4947 218.328 56.5969 213.807 58.7769L214.083 59.3503C218.288 57.323 223.34 59.0878 225.368 63.2923L225.941 63.0158ZM226.201 63.1065C226.104 63.1532 225.988 63.1126 225.941 63.0158L225.368 63.2923C225.567 63.7057 226.064 63.8793 226.477 63.6799L226.201 63.1065ZM226.292 62.8468C226.338 62.9436 226.298 63.0598 226.201 63.1065L226.477 63.6799C226.891 63.4805 227.064 62.9837 226.865 62.5702L226.292 62.8468ZM213.638 58.4264C218.352 56.153 224.018 58.1321 226.292 62.8468L226.865 62.5702C224.438 57.539 218.393 55.4269 213.361 57.853L213.638 58.4264ZM214.193 59.6489C213.779 59.8483 213.606 60.3451 213.805 60.7586L214.378 60.4821C214.332 60.3853 214.372 60.269 214.469 60.2223L214.193 59.6489ZM224.82 63.3615C222.911 59.4018 218.152 57.7396 214.193 59.6489L214.469 60.2223C218.112 58.4657 222.49 59.995 224.247 63.6381L224.82 63.3615ZM224.433 64.4712C224.846 64.2718 225.02 63.775 224.82 63.3615L224.247 63.6381C224.294 63.7348 224.253 63.8511 224.156 63.8978L224.433 64.4712ZM223.323 64.0836C223.522 64.497 224.019 64.6705 224.433 64.4712L224.156 63.8978C224.059 63.9445 223.943 63.9038 223.896 63.807L223.323 64.0836ZM214.915 61.1462C218.047 59.6356 221.812 60.9507 223.323 64.0836L223.896 63.807C222.233 60.3575 218.088 58.9095 214.638 60.5728L214.915 61.1462ZM213.805 60.7586C214.004 61.172 214.501 61.3456 214.915 61.1462L214.638 60.5728C214.541 60.6195 214.425 60.5789 214.378 60.4821L213.805 60.7586ZM214.998 61.5041C214.585 61.7034 214.411 62.2003 214.61 62.6137L215.184 62.3372C215.137 62.2404 215.178 62.1241 215.274 62.0775L214.998 61.5041ZM222.955 64.2837C221.525 61.319 217.963 60.0745 214.998 61.5041L215.274 62.0775C217.923 60.8006 221.105 61.9122 222.382 64.5603L222.955 64.2837ZM222.568 65.3934C222.981 65.194 223.155 64.6972 222.955 64.2837L222.382 64.5603C222.429 64.6571 222.388 64.7733 222.291 64.82L222.568 65.3934ZM221.458 65.0058C221.657 65.4192 222.154 65.5928 222.568 65.3934L222.291 64.82C222.194 64.8667 222.078 64.8261 222.031 64.7292L221.458 65.0058ZM215.72 63.0013C217.858 61.9705 220.427 62.8679 221.458 65.0058L222.031 64.7292C220.848 62.2747 217.898 61.2444 215.444 62.4279L215.72 63.0013ZM214.61 62.6137C214.81 63.0272 215.307 63.2007 215.72 63.0013L215.444 62.4279C215.347 62.4746 215.23 62.434 215.184 62.3372L214.61 62.6137ZM215.787 63.4155C215.374 63.6149 215.2 64.1117 215.4 64.5251L215.973 64.2486C215.927 64.1518 215.967 64.0356 216.064 63.9889L215.787 63.4155ZM221.074 65.2623C220.124 63.2926 217.757 62.4657 215.787 63.4155L216.064 63.9889C217.717 63.1918 219.703 63.8857 220.501 65.5388L221.074 65.2623ZM220.687 66.3719C221.1 66.1725 221.274 65.6757 221.074 65.2623L220.501 65.5388C220.547 65.6356 220.507 65.7519 220.41 65.7985L220.687 66.3719ZM219.577 65.9843C219.776 66.3978 220.273 66.5713 220.687 66.3719L220.41 65.7985C220.313 65.8452 220.197 65.8046 220.15 65.7078L219.577 65.9843ZM216.509 64.9128C217.652 64.3617 219.026 64.8414 219.577 65.9843L220.15 65.7078C219.446 64.2483 217.692 63.6356 216.233 64.3394L216.509 64.9128ZM215.4 64.5252C215.599 64.9386 216.096 65.1121 216.509 64.9128L216.233 64.3394C216.136 64.386 216.02 64.3454 215.973 64.2486L215.4 64.5252ZM218.281 66.0778C218.436 66.3995 218.301 66.786 217.98 66.9411L218.256 67.5145C218.894 67.2067 219.162 66.4396 218.854 65.8013L218.281 66.0778ZM217.418 65.7761C217.739 65.621 218.126 65.7561 218.281 66.0778L218.854 65.8013C218.547 65.1629 217.779 64.8949 217.141 65.2028L217.418 65.7761ZM217.116 66.6395C216.961 66.3178 217.096 65.9313 217.418 65.7761L217.141 65.2028C216.503 65.5106 216.235 66.2776 216.543 66.916L217.116 66.6395ZM217.98 66.9411C217.658 67.0962 217.271 66.9612 217.116 66.6395L216.543 66.916C216.851 67.5543 217.618 67.8223 218.256 67.5145L217.98 66.9411Z"
        fill="url(#paint53_linear_416_7934)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M65.555 124.191C65.4266 124.444 65.527 124.752 65.7795 124.881C66.0319 125.009 66.3407 124.909 66.4692 124.656C68.6663 120.34 73.9468 118.622 78.2637 120.818C78.5162 120.947 78.825 120.846 78.9534 120.594C79.0819 120.342 78.9814 120.033 78.729 119.904C73.9073 117.451 68.0091 119.37 65.555 124.191ZM67.5286 125.806C67.2762 125.677 67.1757 125.369 67.3042 125.116C69.2186 121.355 73.8198 119.858 77.5813 121.772C77.8337 121.9 77.9342 122.209 77.8057 122.462C77.6772 122.714 77.3684 122.815 77.116 122.686C73.8594 121.029 69.8758 122.325 68.2184 125.581C68.0899 125.834 67.7811 125.934 67.5286 125.806ZM69.2932 126.794C69.0408 126.666 68.9403 126.357 69.0688 126.105C70.4821 123.328 73.879 122.223 76.6559 123.636C76.9083 123.764 77.0088 124.073 76.8803 124.325C76.7518 124.578 76.443 124.678 76.1906 124.55C73.9185 123.394 71.1393 124.298 69.983 126.57C69.8545 126.822 69.5457 126.923 69.2932 126.794ZM71.1674 127.663C71.0107 127.583 70.9484 127.391 71.0281 127.235C71.8916 125.538 73.967 124.863 75.6636 125.726C75.8202 125.806 75.8826 125.998 75.8028 126.154C75.7231 126.311 75.5315 126.373 75.3748 126.294C73.9915 125.59 72.2995 126.14 71.5955 127.524C71.5157 127.68 71.3241 127.743 71.1674 127.663ZM74.0233 127.894C74.185 127.976 74.2493 128.174 74.167 128.335C74.0848 128.497 73.8871 128.561 73.7254 128.479C73.5637 128.397 73.4994 128.199 73.5816 128.038C73.6639 127.876 73.8616 127.812 74.0233 127.894ZM74.312 127.327C74.787 127.568 74.9761 128.149 74.7344 128.624C74.4926 129.099 73.9116 129.288 73.4366 129.046C72.9616 128.805 72.7725 128.224 73.0143 127.749C73.256 127.274 73.8371 127.085 74.312 127.327Z"
        fill="url(#paint54_linear_416_7934)"
      />
      <path
        d="M65.7795 124.881L65.9238 124.597L65.7795 124.881ZM65.555 124.191L65.2714 124.047L65.2714 124.047L65.555 124.191ZM66.4692 124.656L66.1856 124.512L66.1856 124.512L66.4692 124.656ZM78.2637 120.818L78.1194 121.102L78.1194 121.102L78.2637 120.818ZM78.729 119.904L78.8734 119.621L78.729 119.904ZM67.3042 125.116L67.0205 124.972L67.3042 125.116ZM77.5813 121.772L77.4369 122.056L77.5813 121.772ZM77.8057 122.462L77.5221 122.317L77.5221 122.317L77.8057 122.462ZM77.116 122.686L77.2603 122.402L77.116 122.686ZM68.2184 125.581L68.502 125.726L68.2184 125.581ZM69.0688 126.105L68.7851 125.96L69.0688 126.105ZM76.6559 123.636L76.5115 123.919L76.5115 123.919L76.6559 123.636ZM76.8803 124.325L77.164 124.47L77.164 124.47L76.8803 124.325ZM76.1906 124.55L76.0462 124.834L76.0462 124.834L76.1906 124.55ZM69.983 126.57L69.6993 126.426L69.983 126.57ZM71.0281 127.235L71.3118 127.379L71.0281 127.235ZM71.1674 127.663L71.3118 127.379L71.3118 127.379L71.1674 127.663ZM75.6636 125.726L75.5192 126.01L75.6636 125.726ZM75.8029 126.154L75.5192 126.01L75.5192 126.01L75.8029 126.154ZM75.3748 126.294L75.5192 126.01L75.3748 126.294ZM71.5955 127.524L71.3118 127.379L71.5955 127.524ZM74.0233 127.894L73.8789 128.178L73.8789 128.178L74.0233 127.894ZM73.7254 128.479L73.8697 128.195L73.8697 128.195L73.7254 128.479ZM74.7344 128.624L74.4507 128.48L74.4507 128.48L74.7344 128.624ZM74.312 127.327L74.4564 127.043L74.4564 127.043L74.312 127.327ZM73.0143 127.749L72.7306 127.604L72.7306 127.604L73.0143 127.749ZM65.9238 124.597C65.8281 124.549 65.79 124.431 65.8387 124.336L65.2714 124.047C65.0632 124.456 65.226 124.956 65.6351 125.165L65.9238 124.597ZM66.1856 124.512C66.1368 124.608 66.0196 124.646 65.9238 124.597L65.6351 125.165C66.0442 125.373 66.5446 125.21 66.7529 124.801L66.1856 124.512ZM78.4081 120.535C73.9345 118.258 68.4623 120.039 66.1856 124.512L66.7529 124.801C68.8702 120.641 73.9591 118.985 78.1194 121.102L78.4081 120.535ZM78.6698 120.45C78.621 120.545 78.5039 120.584 78.4081 120.535L78.1194 121.102C78.5285 121.31 79.0289 121.147 79.2371 120.738L78.6698 120.45ZM78.5846 120.188C78.6804 120.237 78.7185 120.354 78.6698 120.45L79.2371 120.738C79.4453 120.329 79.2825 119.829 78.8734 119.621L78.5846 120.188ZM65.8387 124.336C68.213 119.671 73.9196 117.814 78.5846 120.188L78.8734 119.621C73.895 117.087 67.8052 119.069 65.2714 124.047L65.8387 124.336ZM67.0205 124.972C66.8123 125.381 66.9752 125.881 67.3843 126.09L67.673 125.522C67.5772 125.474 67.5391 125.356 67.5879 125.261L67.0205 124.972ZM77.7256 121.488C73.8075 119.495 69.0147 121.054 67.0205 124.972L67.5879 125.261C69.4225 121.656 73.8321 120.221 77.4369 122.056L77.7256 121.488ZM78.0894 122.606C78.2976 122.197 78.1347 121.697 77.7256 121.488L77.4369 122.056C77.5327 122.104 77.5708 122.222 77.5221 122.317L78.0894 122.606ZM76.9716 122.97C77.3807 123.178 77.8812 123.015 78.0894 122.606L77.5221 122.317C77.4733 122.413 77.3561 122.451 77.2603 122.402L76.9716 122.97ZM68.502 125.726C70.0797 122.626 73.8717 121.392 76.9716 122.97L77.2603 122.402C73.8471 120.666 69.6719 122.024 67.9347 125.437L68.502 125.726ZM67.3843 126.09C67.7934 126.298 68.2938 126.135 68.502 125.726L67.9347 125.437C67.886 125.533 67.7688 125.571 67.673 125.522L67.3843 126.09ZM68.7851 125.96C68.5769 126.369 68.7398 126.87 69.1489 127.078L69.4376 126.511C69.3418 126.462 69.3037 126.345 69.3525 126.249L68.7851 125.96ZM76.8002 123.352C73.8667 121.859 70.2782 123.027 68.7851 125.96L69.3525 126.249C70.686 123.629 73.8913 122.586 76.5115 123.919L76.8002 123.352ZM77.164 124.47C77.3722 124.061 77.2094 123.56 76.8002 123.352L76.5115 123.919C76.6073 123.968 76.6454 124.085 76.5967 124.181L77.164 124.47ZM76.0462 124.834C76.4553 125.042 76.9558 124.879 77.164 124.47L76.5967 124.181C76.5479 124.277 76.4307 124.315 76.335 124.266L76.0462 124.834ZM70.2666 126.714C71.3432 124.599 73.9308 123.757 76.0462 124.834L76.335 124.266C73.9063 123.03 70.9354 123.997 69.6993 126.426L70.2666 126.714ZM69.1489 127.078C69.558 127.286 70.0584 127.123 70.2666 126.714L69.6993 126.426C69.6506 126.521 69.5334 126.559 69.4376 126.511L69.1489 127.078ZM70.7445 127.09C70.585 127.404 70.7097 127.787 71.0231 127.947L71.3118 127.379L71.3118 127.379L70.7445 127.09ZM75.8079 125.443C73.9547 124.5 71.6877 125.237 70.7445 127.09L71.3118 127.379C72.0955 125.839 73.9793 125.226 75.5192 126.01L75.8079 125.443ZM76.0865 126.299C76.246 125.985 76.1213 125.602 75.8079 125.443L75.5192 126.01L75.5192 126.01L76.0865 126.299ZM75.2304 126.577C75.5438 126.737 75.927 126.612 76.0865 126.299L75.5192 126.01L75.5192 126.01L75.2304 126.577ZM71.8791 127.668C72.5034 126.441 74.0038 125.953 75.2304 126.577L75.5192 126.01C73.9792 125.226 72.0955 125.839 71.3118 127.379L71.8791 127.668ZM71.0231 127.947C71.3364 128.106 71.7196 127.981 71.8791 127.668L71.3118 127.379L71.3118 127.379L71.0231 127.947ZM74.4507 128.48C74.6127 128.162 74.486 127.772 74.1676 127.61L73.8789 128.178C73.8839 128.18 73.8859 128.186 73.8834 128.191L74.4507 128.48ZM73.581 128.763C73.8994 128.925 74.2887 128.798 74.4507 128.48L73.8834 128.191C73.8809 128.196 73.8748 128.198 73.8697 128.195L73.581 128.763ZM73.298 127.893C73.136 128.211 73.2627 128.601 73.581 128.763L73.8697 128.195C73.8647 128.193 73.8628 128.187 73.8653 128.182L73.298 127.893ZM74.1676 127.61C73.8493 127.448 73.46 127.575 73.298 127.893L73.8653 128.182C73.8678 128.177 73.8739 128.175 73.8789 128.178L74.1676 127.61ZM75.018 128.769C75.3395 128.137 75.0881 127.364 74.4564 127.043L74.1677 127.61C74.486 127.772 74.6127 128.162 74.4507 128.48L75.018 128.769ZM73.2923 129.33C73.9239 129.652 74.6965 129.4 75.018 128.769L74.4507 128.48C74.2887 128.798 73.8993 128.925 73.581 128.763L73.2923 129.33ZM72.7306 127.604C72.4091 128.236 72.6606 129.009 73.2923 129.33L73.581 128.763C73.2626 128.601 73.136 128.212 73.298 127.893L72.7306 127.604ZM74.4564 127.043C73.8248 126.721 73.0521 126.973 72.7306 127.604L73.298 127.893C73.46 127.575 73.8494 127.448 74.1677 127.61L74.4564 127.043Z"
        fill="url(#paint55_linear_416_7934)"
      />
      <path
        d="M76.6462 22.8369C76.6462 27.363 80.6894 31.0322 85.677 31.0322C90.6646 31.0322 94.7079 27.363 94.7079 22.8369C94.7079 18.3108 90.6646 14.6416 85.677 14.6416C80.6894 14.6416 76.6462 18.3108 76.6462 22.8369Z"
        fill="url(#paint56_linear_416_7934)"
      />
      <path
        d="M83.0478 26.5715C83.0478 31.0976 87.091 34.7668 92.0786 34.7668C97.0662 34.7668 101.109 31.0976 101.109 26.5715C101.109 22.0453 97.0662 18.3762 92.0786 18.3762C87.091 18.3762 83.0478 22.0453 83.0478 26.5715Z"
        fill="url(#paint57_linear_416_7934)"
      />
      <path
        d="M68.1869 27.7126C68.1869 31.3793 71.4624 34.3518 75.503 34.3518C79.5436 34.3518 82.8191 31.3793 82.8191 27.7126C82.8191 24.0458 79.5436 21.0734 75.503 21.0734C71.4624 21.0734 68.1869 24.0458 68.1869 27.7126Z"
        fill="url(#paint58_linear_416_7934)"
      />
      <path
        d="M68.1869 27.7126C68.1869 31.3793 71.4624 34.3518 75.503 34.3518C79.5436 34.3518 82.8191 31.3793 82.8191 27.7126C82.8191 24.0458 79.5436 21.0734 75.503 21.0734C71.4624 21.0734 68.1869 24.0458 68.1869 27.7126Z"
        fill="url(#paint59_linear_416_7934)"
      />
      <path
        d="M90.3639 31.6546C90.3639 35.3214 93.6395 38.2938 97.68 38.2938C101.721 38.2938 104.996 35.3214 104.996 31.6546C104.996 27.9879 101.721 25.0154 97.68 25.0154C93.6395 25.0154 90.3639 27.9879 90.3639 31.6546Z"
        fill="url(#paint60_linear_416_7934)"
      />
      <path
        d="M75.7316 34.7668C75.7316 38.4335 79.0072 41.406 83.0478 41.406C87.0884 41.406 90.3639 38.4335 90.3639 34.7668C90.3639 31.1 87.0884 28.1275 83.0478 28.1275C79.0072 28.1275 75.7316 31.1 75.7316 34.7668Z"
        fill="url(#paint61_linear_416_7934)"
      />
      <path
        d="M83.0478 36.0116C83.0478 39.6784 86.3233 42.6508 90.3639 42.6508C94.4045 42.6508 97.68 39.6784 97.68 36.0116C97.68 32.3449 94.4045 29.3724 90.3639 29.3724C86.3233 29.3724 83.0478 32.3449 83.0478 36.0116Z"
        fill="url(#paint62_linear_416_7934)"
      />
      <path
        d="M62.4711 31.0322C62.4711 33.7822 64.9278 36.0116 67.9582 36.0116C70.9887 36.0116 73.4453 33.7822 73.4453 31.0322C73.4453 28.2821 70.9887 26.0528 67.9582 26.0528C64.9278 26.0528 62.4711 28.2821 62.4711 31.0322Z"
        fill="url(#paint63_linear_416_7934)"
      />
      <path
        d="M99.5091 33.9369C99.5091 36.6869 101.966 38.9163 104.996 38.9163C108.027 38.9163 110.483 36.6869 110.483 33.9369C110.483 31.1868 108.027 28.9574 104.996 28.9574C101.966 28.9574 99.5091 31.1868 99.5091 33.9369Z"
        fill="url(#paint64_linear_416_7934)"
      />
      <path
        d="M94.7079 37.6714C94.7079 40.4215 97.1645 42.6508 100.195 42.6508C103.225 42.6508 105.682 40.4215 105.682 37.6714C105.682 34.9214 103.225 32.692 100.195 32.692C97.1645 32.692 94.7079 34.9214 94.7079 37.6714Z"
        fill="url(#paint65_linear_416_7934)"
      />
      <path
        d="M102.939 37.049C102.939 39.799 105.395 42.0284 108.426 42.0284C111.456 42.0284 113.913 39.799 113.913 37.049C113.913 34.2989 111.456 32.0696 108.426 32.0696C105.395 32.0696 102.939 34.2989 102.939 37.049Z"
        fill="url(#paint66_linear_416_7934)"
      />
      <path
        d="M68.1869 36.0116C68.1869 38.7617 70.6435 40.991 73.674 40.991C76.7044 40.991 79.1611 38.7617 79.1611 36.0116C79.1611 33.2616 76.7044 31.0322 73.674 31.0322C70.6435 31.0322 68.1869 33.2616 68.1869 36.0116Z"
        fill="url(#paint67_linear_416_7934)"
      />
      <path
        d="M59.2703 34.663C59.2703 36.6683 61.0616 38.2938 63.2713 38.2938C65.481 38.2938 67.2724 36.6683 67.2724 34.663C67.2724 32.6578 65.481 31.0322 63.2713 31.0322C61.0616 31.0322 59.2703 32.6578 59.2703 34.663Z"
        fill="url(#paint68_linear_416_7934)"
      />
      <path
        d="M63.157 36.9453C63.157 38.9505 64.9483 40.5761 67.158 40.5761C69.3677 40.5761 71.159 38.9505 71.159 36.9453C71.159 34.94 69.3677 33.3144 67.158 33.3144C64.9483 33.3144 63.157 34.94 63.157 36.9453Z"
        fill="url(#paint69_linear_416_7934)"
      />
      <path
        d="M110.026 37.3602C110.026 39.3655 111.817 40.991 114.027 40.991C116.237 40.991 118.028 39.3655 118.028 37.3602C118.028 35.355 116.237 33.7294 114.027 33.7294C111.817 33.7294 110.026 35.355 110.026 37.3602Z"
        fill="url(#paint70_linear_416_7934)"
      />
      <path
        d="M55.6123 36.9453C55.6123 38.3776 56.8918 39.5387 58.4701 39.5387C60.0485 39.5387 61.328 38.3776 61.328 36.9453C61.328 35.5129 60.0485 34.3518 58.4701 34.3518C56.8918 34.3518 55.6123 35.5129 55.6123 36.9453Z"
        fill="url(#paint71_linear_416_7934)"
      />
      <path
        d="M114.827 37.3602C114.827 38.7925 116.107 39.9537 117.685 39.9537C119.263 39.9537 120.543 38.7925 120.543 37.3602C120.543 35.9279 119.263 34.7668 117.685 34.7668C116.107 34.7668 114.827 35.9279 114.827 37.3602Z"
        fill="url(#paint72_linear_416_7934)"
      />
      <path
        d="M172.211 65.3824L172.507 65.5308C172.755 65.6552 172.855 65.9572 172.731 66.2053L172.638 66.3903C172.626 66.3891 172.614 66.3878 172.602 66.3864C172.476 66.3718 172.387 66.3809 172.317 66.3979C172.269 66.4097 172.23 66.4254 172.196 66.4391C172.181 66.4451 172.168 66.4507 172.154 66.4554C172.11 66.4712 172.07 66.4785 172.018 66.4623C171.966 66.446 171.9 66.4056 171.804 66.3242C171.613 66.1617 171.517 65.9996 171.502 65.844C171.492 65.7437 171.516 65.6454 171.569 65.5506C171.708 65.3438 171.982 65.2677 172.211 65.3824ZM172.652 66.3918L172.743 66.2114C172.871 65.9566 172.768 65.6465 172.513 65.5187L172.217 65.3703C172.02 65.2715 171.79 65.3107 171.637 65.4514C171.651 65.4332 171.667 65.4152 171.684 65.3974C171.811 65.2621 172.001 65.2273 172.196 65.231C172.33 65.2336 172.466 65.2544 172.583 65.2725C172.636 65.2806 172.685 65.2881 172.729 65.2932C173.012 65.3261 173.298 65.2744 173.551 65.1447C173.805 65.015 174.014 64.8131 174.153 64.5645C174.291 64.3158 174.353 64.0317 174.33 63.748C174.307 63.4643 174.201 63.1937 174.024 62.9706C173.847 62.7474 173.608 62.5816 173.338 62.4942C173.067 62.4067 172.776 62.4016 172.502 62.4794C172.228 62.5572 171.984 62.7144 171.799 62.9312C171.778 62.9564 171.744 62.9709 171.701 62.9755C171.658 62.9802 171.607 62.9749 171.55 62.9612C171.437 62.9339 171.307 62.8732 171.193 62.7939C171.078 62.7145 170.98 62.6168 170.931 62.5157C170.907 62.4653 170.894 62.4142 170.898 62.3642C170.902 62.3143 170.921 62.265 170.961 62.2181C171.287 61.8355 171.718 61.558 172.201 61.4207C172.685 61.2834 173.198 61.2925 173.676 61.4468C174.154 61.6011 174.575 61.8937 174.887 62.2875C175.199 62.6814 175.387 63.1588 175.427 63.6595C175.467 64.1602 175.358 64.6616 175.114 65.1003C174.869 65.5391 174.5 65.8954 174.053 66.1244C173.621 66.3456 173.135 66.4382 172.652 66.3918ZM170.475 67.7231L171.504 65.6704C171.488 65.7277 171.483 65.7861 171.489 65.8453C171.505 66.0057 171.603 66.1707 171.795 66.3345C171.891 66.4162 171.959 66.4581 172.014 66.4752C172.07 66.4925 172.113 66.4845 172.159 66.4681C172.173 66.4631 172.187 66.4573 172.202 66.4512C172.236 66.4376 172.273 66.4226 172.32 66.411C172.388 66.3944 172.476 66.3853 172.6 66.3998C172.611 66.401 172.621 66.4022 172.631 66.4032L171.669 68.3222C171.544 68.5702 171.242 68.6705 170.994 68.546L170.698 68.3976C170.45 68.2732 170.35 67.9712 170.475 67.7231ZM170.978 69.6992C170.813 70.029 170.411 70.1623 170.082 69.9969C169.752 69.8314 169.618 69.43 169.784 69.1002C169.949 68.7704 170.351 68.6371 170.681 68.8026C171.01 68.968 171.144 69.3694 170.978 69.6992Z"
        fill="url(#paint73_linear_416_7934)"
        stroke="url(#paint74_linear_416_7934)"
        stroke-width="0.0134962"
      />
      <path
        d="M117.125 68.514L117.437 68.4039C117.699 68.3116 117.986 68.4489 118.078 68.7107L118.147 68.9059C118.138 68.9137 118.129 68.9214 118.119 68.9291C118.022 69.0095 117.966 69.0803 117.93 69.1421C117.905 69.185 117.89 69.2238 117.876 69.2579C117.87 69.2726 117.864 69.2864 117.859 69.2993C117.839 69.342 117.817 69.3757 117.769 69.402C117.721 69.4287 117.646 69.4481 117.521 69.4605C117.271 69.4854 117.088 69.4416 116.966 69.3447C116.887 69.2822 116.832 69.1972 116.801 69.0932C116.748 68.8495 116.884 68.5991 117.125 68.514ZM118.158 68.8965L118.091 68.7062C117.996 68.4374 117.702 68.2964 117.433 68.3912L117.121 68.5013C116.913 68.5746 116.781 68.7675 116.776 68.9755C116.773 68.9524 116.771 68.9286 116.77 68.9042C116.761 68.7185 116.868 68.5576 117.006 68.4199C117.101 68.3248 117.21 68.2417 117.304 68.1695C117.347 68.1372 117.386 68.107 117.42 68.079C117.64 67.8982 117.802 67.6563 117.884 67.3838C117.966 67.1114 117.966 66.8206 117.883 66.5483C117.8 66.276 117.639 66.0344 117.418 65.854C117.198 65.6737 116.929 65.5626 116.646 65.535C116.363 65.5074 116.078 65.5644 115.827 65.6988C115.576 65.8332 115.37 66.039 115.237 66.2901C115.103 66.5413 115.046 66.8265 115.074 67.1097C115.078 67.1427 115.065 67.177 115.038 67.2112C115.012 67.2454 114.972 67.2789 114.923 67.31C114.825 67.3722 114.691 67.4239 114.555 67.4512C114.418 67.4786 114.28 67.4814 114.173 67.4467C114.119 67.4294 114.074 67.4028 114.041 67.3655C114.007 67.3283 113.985 67.28 113.979 67.2186C113.929 66.7188 114.029 66.2155 114.265 65.7722C114.502 65.329 114.864 64.9659 115.307 64.7287C115.75 64.4915 116.253 64.3909 116.753 64.4396C117.253 64.4884 117.727 64.6843 118.116 65.0026C118.504 65.3209 118.79 65.7473 118.936 66.2278C119.082 66.7084 119.083 67.2215 118.937 67.7023C118.797 68.167 118.526 68.5813 118.158 68.8965ZM117.606 71.3885L116.842 69.2228C116.872 69.274 116.911 69.3184 116.957 69.3553C117.084 69.4552 117.271 69.499 117.522 69.474C117.648 69.4615 117.725 69.4418 117.776 69.4138C117.827 69.3856 117.851 69.3491 117.871 69.3048C117.877 69.2911 117.883 69.2768 117.889 69.2619C117.902 69.2282 117.917 69.1909 117.942 69.1489C117.977 69.0886 118.031 69.019 118.128 68.9395C118.136 68.9329 118.144 68.9262 118.152 68.9195L118.866 70.944C118.958 71.2058 118.821 71.4928 118.559 71.5851L118.247 71.6952C117.985 71.7875 117.698 71.6502 117.606 71.3885ZM119.379 72.3969C119.501 72.7448 119.319 73.1264 118.971 73.2491C118.623 73.3719 118.241 73.1893 118.118 72.8413C117.996 72.4934 118.178 72.1118 118.526 71.9891C118.874 71.8664 119.256 72.0489 119.379 72.3969Z"
        fill="url(#paint75_linear_416_7934)"
        stroke="url(#paint76_linear_416_7934)"
        stroke-width="0.0134962"
      />
      <path
        d="M154.963 108.064C154.963 108.064 155.676 108.644 156.368 108.985C157.104 109.348 158.567 109.75 158.567 109.75"
        stroke="url(#paint77_linear_416_7934)"
        stroke-width="0.57113"
        stroke-linecap="round"
      />
      <path
        d="M105.36 114.769C105.36 114.769 106.273 114.658 106.999 114.398C107.772 114.122 109.077 113.349 109.077 113.349"
        stroke="url(#paint78_linear_416_7934)"
        stroke-width="0.57113"
        stroke-linecap="round"
      />
      <path
        d="M196.456 83.1846C196.456 83.1846 195.982 82.3971 195.447 81.8408C194.879 81.2494 193.64 80.3744 193.64 80.3744"
        stroke="url(#paint79_linear_416_7934)"
        stroke-width="0.57113"
        stroke-linecap="round"
      />
      <path
        d="M76.6279 80.3418C76.6279 80.3418 75.7653 80.6591 75.1183 81.0795C74.4304 81.5265 73.3377 82.5787 73.3377 82.5787"
        stroke="url(#paint80_linear_416_7934)"
        stroke-width="0.57113"
        stroke-linecap="round"
      />
      <path
        d="M70.6748 99.6989C70.6748 99.6989 54.2605 92.8943 45.8489 97.7733C38.3695 102.112 32.335 115.745 42.0556 120.867C51.1615 125.664 54.9765 117.606 56.0275 114.758C61.4747 99.9956 37.0001 103.017 23.7663 111.529C11.4765 119.434 7.04067 145 7.04067 145"
        stroke="url(#paint81_linear_416_7934)"
        stroke-width="4.77431"
        stroke-linecap="round"
      />
      <path
        d="M84.2996 79.4655C79.5905 79.9807 75.279 82.3455 72.3135 86.0397C69.348 89.7338 67.9714 94.4547 68.4867 99.1638C69.0019 103.873 71.3667 108.184 75.0609 111.15C78.755 114.115 83.4759 115.492 88.185 114.977L84.2996 79.4655Z"
        fill="url(#paint82_linear_416_7934)"
      />
      <path
        d="M83.2342 79.582L102.41 77.4839L106.296 112.995L87.1197 115.093L83.2342 79.582Z"
        fill="url(#paint83_linear_416_7934)"
      />
      <ellipse
        cx="9.97555"
        cy="17.8615"
        rx="9.97555"
        ry="17.8615"
        transform="matrix(0.994067 -0.108765 0.108766 0.994067 91.7568 78.6504)"
        fill="url(#paint84_linear_416_7934)"
      />
      <rect
        width="19.6478"
        height="4.64399"
        rx="2.322"
        transform="matrix(0.994067 -0.108765 0.108766 0.994067 101.684 87.2656)"
        fill="url(#paint85_linear_416_7934)"
      />
      <rect
        width="19.6478"
        height="4.64399"
        rx="2.322"
        transform="matrix(0.994067 -0.108765 0.108766 0.994067 102.966 98.9854)"
        fill="url(#paint86_linear_416_7934)"
      />
      <path
        d="M198.103 95.7222C198.103 95.7222 216.969 84.6289 224.546 91.8101C232.214 99.0783 232.139 117.844 222.037 114.748C215.144 112.636 210.871 108.829 213.799 102.241C217.628 93.626 243.864 99.4691 249.395 106.134C255.12 113.033 253.946 124.071 244.989 124.463C236.672 124.826 237.516 116.854 242.158 113.747C246.801 110.64 272.477 120.505 291.096 134.708"
        stroke="url(#paint87_linear_416_7934)"
        stroke-width="4.77431"
        stroke-linecap="round"
      />
      <path
        opacity="0.5"
        d="M71.3457 63.3506C71.1907 64.0365 70.5091 64.4669 69.8233 64.3119C69.1374 64.1569 68.7071 63.4752 68.8621 62.7893C69.0171 62.1034 69.6987 61.6731 70.3845 61.8281C71.0704 61.9831 71.5007 62.6647 71.3457 63.3506Z"
        fill="url(#paint88_linear_416_7934)"
        stroke="url(#paint89_linear_416_7934)"
        stroke-width="1.27319"
      />
      <path
        opacity="0.5"
        d="M75.6328 61.71C75.4778 62.3959 74.7962 62.8262 74.1104 62.6713C73.4245 62.5163 72.9942 61.8346 73.1492 61.1487C73.3042 60.4628 73.9858 60.0324 74.6717 60.1874C75.3575 60.3424 75.7878 61.0241 75.6328 61.71Z"
        fill="url(#paint90_linear_416_7934)"
        stroke="url(#paint91_linear_416_7934)"
        stroke-width="1.27319"
      />
      <path
        opacity="0.5"
        d="M79.9199 60.0674C79.7649 60.7533 79.0833 61.1837 78.3975 61.0287C77.7117 60.8737 77.2813 60.192 77.4363 59.5061C77.5913 58.8202 78.273 58.3899 78.9588 58.5449C79.6446 58.6998 80.0749 59.3815 79.9199 60.0674Z"
        fill="url(#paint92_linear_416_7934)"
        stroke="url(#paint93_linear_416_7934)"
        stroke-width="1.27319"
      />
      <g opacity="0.5">
        <mask id="path-25-inside-1_416_7934" fill="white">
          <ellipse
            cx="1.90977"
            cy="1.90979"
            rx="1.90977"
            ry="1.90979"
            transform="matrix(0.788957 0.614448 -0.614405 0.788991 189.921 120.175)"
          />
        </mask>
        <ellipse
          cx="1.90977"
          cy="1.90979"
          rx="1.90977"
          ry="1.90979"
          transform="matrix(0.788957 0.614448 -0.614405 0.788991 189.921 120.175)"
          fill="url(#paint94_linear_416_7934)"
        />
        <path
          d="M190.254 122.855L190.254 122.855L187.907 125.869C189.572 127.165 191.972 126.866 193.268 125.202L190.254 122.855ZM190.254 122.855L190.254 122.855L187.241 120.508C185.945 122.173 186.243 124.572 187.907 125.869L190.254 122.855ZM190.254 122.855L190.254 122.855L192.601 119.841C190.937 118.545 188.537 118.844 187.241 120.508L190.254 122.855ZM190.254 122.855L190.254 122.855L193.268 125.202C194.564 123.538 194.265 121.138 192.601 119.841L190.254 122.855Z"
          fill="url(#paint95_linear_416_7934)"
          mask="url(#path-25-inside-1_416_7934)"
        />
      </g>
      <g opacity="0.5">
        <mask id="path-27-inside-2_416_7934" fill="white">
          <ellipse
            cx="1.90977"
            cy="1.90979"
            rx="1.90977"
            ry="1.90979"
            transform="matrix(0.788957 0.614448 -0.614405 0.788991 194.499 120.513)"
          />
        </mask>
        <ellipse
          cx="1.90977"
          cy="1.90979"
          rx="1.90977"
          ry="1.90979"
          transform="matrix(0.788957 0.614448 -0.614405 0.788991 194.499 120.513)"
          fill="url(#paint96_linear_416_7934)"
        />
        <path
          d="M194.832 123.193L194.832 123.193L192.486 126.207C194.15 127.503 196.55 127.204 197.846 125.54L194.832 123.193ZM194.832 123.193L194.832 123.193L191.819 120.846C190.523 122.51 190.821 124.91 192.486 126.207L194.832 123.193ZM194.832 123.193L194.832 123.193L197.179 120.179C195.515 118.883 193.115 119.182 191.819 120.846L194.832 123.193ZM194.832 123.193L194.832 123.193L197.846 125.54C199.142 123.876 198.843 121.476 197.179 120.179L194.832 123.193Z"
          fill="url(#paint97_linear_416_7934)"
          mask="url(#path-27-inside-2_416_7934)"
        />
      </g>
      <path
        opacity="0.5"
        d="M200.415 124.313C199.983 124.868 199.183 124.967 198.628 124.535C198.073 124.103 197.974 123.303 198.406 122.749C198.838 122.194 199.638 122.094 200.193 122.526C200.747 122.958 200.847 123.758 200.415 124.313Z"
        fill="url(#paint98_linear_416_7934)"
        stroke="url(#paint99_linear_416_7934)"
        stroke-width="1.27319"
      />
      <path
        d="M175.703 112.917C180.278 114.146 185.154 113.507 189.257 111.141C193.361 108.774 196.357 104.875 197.586 100.299C198.814 95.7244 198.175 90.8486 195.809 86.7448C193.442 82.641 189.543 79.6453 184.967 78.4167L175.703 112.917Z"
        fill="url(#paint100_linear_416_7934)"
      />
      <path
        d="M176.738 113.195L158.107 108.192L167.372 73.6917L186.002 78.6947L176.738 113.195Z"
        fill="url(#paint101_linear_416_7934)"
      />
      <ellipse
        cx="9.97555"
        cy="17.8615"
        rx="9.97555"
        ry="17.8615"
        transform="matrix(-0.965784 -0.259348 0.25935 -0.965783 168.457 110.972)"
        fill="url(#paint102_linear_416_7934)"
      />
      <rect
        width="5.35848"
        height="5.35846"
        rx="2.67923"
        transform="matrix(-0.965784 -0.259348 0.25935 -0.965783 163.276 99.9629)"
        fill="url(#paint103_linear_416_7934)"
      />
      <rect
        width="5.35848"
        height="5.35846"
        rx="2.67923"
        transform="matrix(-0.965784 -0.259348 0.25935 -0.965783 166.334 88.5781)"
        fill="url(#paint104_linear_416_7934)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_416_7934"
          x1="24.4143"
          y1="14.8869"
          x2="283.585"
          y2="98.6726"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6DCCFF" />
          <stop offset="1" stop-color="#9CDFFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_416_7934"
          x1="176.714"
          y1="35.0219"
          x2="222.345"
          y2="-11.1759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_416_7934"
          x1="176.714"
          y1="35.0219"
          x2="222.345"
          y2="-11.1759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_416_7934"
          x1="176.714"
          y1="35.0219"
          x2="222.345"
          y2="-11.1759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_416_7934"
          x1="176.714"
          y1="35.0219"
          x2="222.345"
          y2="-11.1759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_416_7934"
          x1="176.714"
          y1="35.0219"
          x2="222.345"
          y2="-11.1759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_416_7934"
          x1="176.714"
          y1="35.0219"
          x2="222.345"
          y2="-11.1759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_416_7934"
          x1="176.714"
          y1="35.0219"
          x2="222.345"
          y2="-11.1759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_416_7934"
          x1="176.714"
          y1="35.0219"
          x2="222.345"
          y2="-11.1759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_416_7934"
          x1="176.714"
          y1="35.0219"
          x2="222.345"
          y2="-11.1759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_416_7934"
          x1="176.714"
          y1="35.0219"
          x2="222.345"
          y2="-11.1759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_416_7934"
          x1="176.714"
          y1="35.0219"
          x2="222.345"
          y2="-11.1759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_416_7934"
          x1="176.714"
          y1="35.0219"
          x2="222.345"
          y2="-11.1759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_416_7934"
          x1="176.714"
          y1="35.0219"
          x2="222.345"
          y2="-11.1759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_416_7934"
          x1="176.714"
          y1="35.0219"
          x2="222.345"
          y2="-11.1759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_416_7934"
          x1="176.714"
          y1="35.0219"
          x2="222.345"
          y2="-11.1759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_416_7934"
          x1="176.714"
          y1="35.0219"
          x2="222.345"
          y2="-11.1759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_416_7934"
          x1="176.714"
          y1="35.0219"
          x2="222.345"
          y2="-11.1759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_416_7934"
          x1="146.471"
          y1="2.43907"
          x2="211.805"
          y2="29.5576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_416_7934"
          x1="146.471"
          y1="2.43907"
          x2="211.805"
          y2="29.5576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_416_7934"
          x1="146.471"
          y1="2.43907"
          x2="211.805"
          y2="29.5576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_416_7934"
          x1="146.471"
          y1="2.43907"
          x2="211.805"
          y2="29.5576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_416_7934"
          x1="146.471"
          y1="2.43907"
          x2="211.805"
          y2="29.5576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_416_7934"
          x1="146.471"
          y1="2.43907"
          x2="211.805"
          y2="29.5576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_416_7934"
          x1="146.471"
          y1="2.43907"
          x2="211.805"
          y2="29.5576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_416_7934"
          x1="146.471"
          y1="2.43907"
          x2="211.805"
          y2="29.5576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_416_7934"
          x1="146.471"
          y1="2.43907"
          x2="211.805"
          y2="29.5576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_416_7934"
          x1="146.471"
          y1="2.43907"
          x2="211.805"
          y2="29.5576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_416_7934"
          x1="146.471"
          y1="2.43907"
          x2="211.805"
          y2="29.5576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_416_7934"
          x1="146.471"
          y1="2.43907"
          x2="211.805"
          y2="29.5576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_416_7934"
          x1="146.471"
          y1="2.43907"
          x2="211.805"
          y2="29.5576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_416_7934"
          x1="146.471"
          y1="2.43907"
          x2="211.805"
          y2="29.5576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_416_7934"
          x1="146.471"
          y1="2.43907"
          x2="211.805"
          y2="29.5576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_416_7934"
          x1="146.471"
          y1="2.43907"
          x2="211.805"
          y2="29.5576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_416_7934"
          x1="146.471"
          y1="2.43907"
          x2="211.805"
          y2="29.5576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_416_7934"
          x1="106.388"
          y1="23.5639"
          x2="60.7566"
          y2="-22.6339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint36_linear_416_7934"
          x1="106.388"
          y1="23.5639"
          x2="60.7566"
          y2="-22.6339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint37_linear_416_7934"
          x1="106.388"
          y1="23.5639"
          x2="60.7566"
          y2="-22.6339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint38_linear_416_7934"
          x1="106.388"
          y1="23.5639"
          x2="60.7566"
          y2="-22.6339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_416_7934"
          x1="106.388"
          y1="23.5639"
          x2="60.7566"
          y2="-22.6339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_416_7934"
          x1="106.388"
          y1="23.5639"
          x2="60.7566"
          y2="-22.6339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_416_7934"
          x1="106.388"
          y1="23.5639"
          x2="60.7566"
          y2="-22.6339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_416_7934"
          x1="106.388"
          y1="23.5639"
          x2="60.7566"
          y2="-22.6339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_416_7934"
          x1="106.388"
          y1="23.5639"
          x2="60.7566"
          y2="-22.6339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_416_7934"
          x1="106.388"
          y1="23.5639"
          x2="60.7566"
          y2="-22.6339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_416_7934"
          x1="106.388"
          y1="23.5639"
          x2="60.7566"
          y2="-22.6339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint46_linear_416_7934"
          x1="106.388"
          y1="23.5639"
          x2="60.7566"
          y2="-22.6339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint47_linear_416_7934"
          x1="106.388"
          y1="23.5639"
          x2="60.7566"
          y2="-22.6339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint48_linear_416_7934"
          x1="106.388"
          y1="23.5639"
          x2="60.7566"
          y2="-22.6339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_416_7934"
          x1="106.388"
          y1="23.5639"
          x2="60.7566"
          y2="-22.6339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint50_linear_416_7934"
          x1="106.388"
          y1="23.5639"
          x2="60.7566"
          y2="-22.6339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint51_linear_416_7934"
          x1="106.388"
          y1="23.5639"
          x2="60.7566"
          y2="-22.6339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint52_linear_416_7934"
          x1="213.974"
          y1="56.2002"
          x2="228.462"
          y2="66.1779"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint53_linear_416_7934"
          x1="213.974"
          y1="56.2002"
          x2="228.462"
          y2="66.1779"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint54_linear_416_7934"
          x1="64.7582"
          y1="122.36"
          x2="82.3295"
          y2="121.524"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint55_linear_416_7934"
          x1="64.7582"
          y1="122.36"
          x2="82.3295"
          y2="121.524"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint56_linear_416_7934"
          x1="120.731"
          y1="17.0594"
          x2="51.5425"
          y2="48.7053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint57_linear_416_7934"
          x1="120.731"
          y1="17.0594"
          x2="51.5425"
          y2="48.7053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint58_linear_416_7934"
          x1="120.731"
          y1="17.0594"
          x2="51.5425"
          y2="48.7053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint59_linear_416_7934"
          x1="120.731"
          y1="17.0594"
          x2="51.5425"
          y2="48.7053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint60_linear_416_7934"
          x1="120.731"
          y1="17.0594"
          x2="51.5425"
          y2="48.7053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint61_linear_416_7934"
          x1="120.731"
          y1="17.0594"
          x2="51.5425"
          y2="48.7053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint62_linear_416_7934"
          x1="120.731"
          y1="17.0594"
          x2="51.5425"
          y2="48.7053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint63_linear_416_7934"
          x1="120.731"
          y1="17.0594"
          x2="51.5425"
          y2="48.7053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint64_linear_416_7934"
          x1="120.731"
          y1="17.0594"
          x2="51.5425"
          y2="48.7053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint65_linear_416_7934"
          x1="120.731"
          y1="17.0594"
          x2="51.5425"
          y2="48.7053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint66_linear_416_7934"
          x1="120.731"
          y1="17.0594"
          x2="51.5425"
          y2="48.7053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint67_linear_416_7934"
          x1="120.731"
          y1="17.0594"
          x2="51.5425"
          y2="48.7053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint68_linear_416_7934"
          x1="120.731"
          y1="17.0594"
          x2="51.5425"
          y2="48.7053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint69_linear_416_7934"
          x1="120.731"
          y1="17.0594"
          x2="51.5425"
          y2="48.7053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint70_linear_416_7934"
          x1="120.731"
          y1="17.0594"
          x2="51.5425"
          y2="48.7053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint71_linear_416_7934"
          x1="120.731"
          y1="17.0594"
          x2="51.5425"
          y2="48.7053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint72_linear_416_7934"
          x1="120.731"
          y1="17.0594"
          x2="51.5425"
          y2="48.7053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint73_linear_416_7934"
          x1="171.446"
          y1="61.1854"
          x2="176.866"
          y2="64.669"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint74_linear_416_7934"
          x1="171.446"
          y1="61.1854"
          x2="176.866"
          y2="64.669"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint75_linear_416_7934"
          x1="113.572"
          y1="66.1533"
          x2="119.841"
          y2="64.667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint76_linear_416_7934"
          x1="113.572"
          y1="66.1533"
          x2="119.841"
          y2="64.667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint77_linear_416_7934"
          x1="154.944"
          y1="108.078"
          x2="154.733"
          y2="109.56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint78_linear_416_7934"
          x1="105.357"
          y1="114.792"
          x2="106.275"
          y2="115.973"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint79_linear_416_7934"
          x1="196.479"
          y1="83.1781"
          x2="197.18"
          y2="81.8565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint80_linear_416_7934"
          x1="76.6258"
          y1="80.3182"
          x2="75.46"
          y2="79.3803"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint81_linear_416_7934"
          x1="78.8134"
          y1="127.576"
          x2="7.75739"
          y2="90.5304"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint82_linear_416_7934"
          x1="107.705"
          y1="107.137"
          x2="62.9152"
          y2="92.9653"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint83_linear_416_7934"
          x1="107.705"
          y1="107.137"
          x2="62.9152"
          y2="92.9653"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint84_linear_416_7934"
          x1="-0.0576833"
          y1="3.08366"
          x2="25.3407"
          y2="5.88239"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint85_linear_416_7934"
          x1="20.7577"
          y1="3.90695"
          x2="14.4232"
          y2="-7.79739"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint86_linear_416_7934"
          x1="20.7577"
          y1="3.90695"
          x2="14.4232"
          y2="-7.79739"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint87_linear_416_7934"
          x1="297.166"
          y1="129.444"
          x2="244.938"
          y2="55.0965"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint88_linear_416_7934"
          x1="68.5787"
          y1="61.1053"
          x2="72.9931"
          y2="63.061"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint89_linear_416_7934"
          x1="68.5787"
          y1="61.1053"
          x2="72.9931"
          y2="63.061"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint90_linear_416_7934"
          x1="72.8658"
          y1="59.4647"
          x2="77.2802"
          y2="61.4204"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint91_linear_416_7934"
          x1="72.8658"
          y1="59.4647"
          x2="77.2802"
          y2="61.4204"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint92_linear_416_7934"
          x1="77.1529"
          y1="57.8221"
          x2="81.5674"
          y2="59.7778"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint93_linear_416_7934"
          x1="77.1529"
          y1="57.8221"
          x2="81.5674"
          y2="59.7778"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint94_linear_416_7934"
          x1="-0.0110432"
          y1="0.329711"
          x2="4.72599"
          y2="1.26433"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint95_linear_416_7934"
          x1="189.71"
          y1="120.428"
          x2="192.873"
          y2="124.076"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint96_linear_416_7934"
          x1="-0.0110432"
          y1="0.329711"
          x2="4.72599"
          y2="1.26433"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint97_linear_416_7934"
          x1="194.288"
          y1="120.766"
          x2="197.451"
          y2="124.414"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint98_linear_416_7934"
          x1="198.866"
          y1="121.104"
          x2="202.029"
          y2="124.752"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint99_linear_416_7934"
          x1="198.866"
          y1="121.104"
          x2="202.029"
          y2="124.752"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint100_linear_416_7934"
          x1="163.933"
          y1="78.6386"
          x2="200.528"
          y2="108.097"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint101_linear_416_7934"
          x1="163.933"
          y1="78.6386"
          x2="200.528"
          y2="108.097"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint102_linear_416_7934"
          x1="-0.0576833"
          y1="3.08366"
          x2="25.3407"
          y2="5.88239"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAE7FF" />
          <stop offset="1" stop-color="#E6F7FF" />
        </linearGradient>
        <linearGradient
          id="paint103_linear_416_7934"
          x1="5.66119"
          y1="4.50802"
          x2="-0.742966"
          y2="1.71114"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
        <linearGradient
          id="paint104_linear_416_7934"
          x1="5.66119"
          y1="4.50802"
          x2="-0.742966"
          y2="1.71114"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#40A9FF" />
          <stop offset="1" stop-color="#096DD9" />
        </linearGradient>
      </defs>
    </svg>
  );
}
